export default __webpack_public_path__ + "static/media/AnupamGhosh_CV1.475ed9e6.pdf";